import { render } from "./AdminViewPR.vue?vue&type=template&id=59482aae"
import script from "./AdminViewPR.vue?vue&type=script&lang=js"
export * from "./AdminViewPR.vue?vue&type=script&lang=js"

import "./AdminViewPR.vue?vue&type=style&index=0&id=59482aae&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__